import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';
import { Link, Box, Button } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { listApprovals } from '../../../modules/userModule/approvals';
import ApprovalList from '../../../components/dashboard/approval/ApprovalList';

const ApprovalNowListContainer = ({ handleOpen }) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const { approvals, error, loading } = useSelector(
    ({ userModule, loading }) => ({
      approvals: userModule.approvals.approvals,
      error: userModule.approvals.error,
      loading: loading['user/LIST_USER_APPROVALS'],
    }),
  );

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
        disableExport: true,
      },
      {
        field: 'apprUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
        disableExport: true,
      },
      {
        field: 'docuUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
        disableExport: true,
      },
      {
        field: 'docuCd',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
        disableExport: true,
      },
      {
        field: 'docuTyp',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
        disableExport: true,
      },
      {
        field: 'docuNo',
        headerName: '문서번호',
        minWidth: 120,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => (
          <Link
            underline="none"
            component={RouterLink}
            to={`/approvalmng/${params.row.docuUuid}`}
          >
            {params.value}
          </Link>
        ),
      },
      {
        field: 'clientInc',
        headerName: '고객명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'cstNm',
        headerName: '사업명',
        minWidth: 300,
        flex: 1,
        type: 'string',
        editable: false,
      },

      {
        field: 'crtUsrNm',
        headerName: '영업 담당자',
        minWidth: 150,
        flex: 0.8,
        type: 'string',
        editable: false,
      },

      {
        field: 'crtDt',
        headerName: '등록일자',
        minWidth: 150,
        flex: 0.8,
        type: 'string',
        editable: false,
      },
    ],
    [],
  );

  const handleClick = () => {
    navigate(`/approvalmng`);
  };

  // 컴포넌트 마운트 후 list 데이터 요청
  useEffect(() => {
    dispatch(listApprovals());
  }, []);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItem: 'center',
          my: 2,
        }}
      >
        <Button onClick={handleClick} variant="contained">
          결재관리
        </Button>
      </Box>
      <ApprovalList columns={columns} rows={approvals} loading={loading} />
    </>
  );
};

export default ApprovalNowListContainer;
